



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from 'sweetalert2';
import store from '@/store';

extend('required', required);

export interface Contact {
  id: never;
  name: never;
  tel: never;
  address: never;
}

@Component({
})

export default class ContactList extends Vue {
    private filrerList = '';
    private contact = [] as Contact[];
    private selectAll = false;
    private selectedContact = [];
    private loading = false;
    private selectMode = false;
    private receiverContact = false;
    private refCode = '';

    private created() {
      this.refCode = store.getters.refCode;
      this.getMyContact();
    }

    get hasContact() {
      return this.contact.length > 0;
    }

    @Watch('selectAll')
    private selectAllChange(value: string, oldValue: string) {
      if (value) {
        this.selectedContact = [];
        for (const c of this.contact) {
          // index start from 0
          if (this.selectedContact.length > 19) {
            break;
          } else {
            this.selectedContact.push(c.id);
          }
        }
      } else {
        this.selectedContact = [];
      }
    }

    @Watch('selectMode')
    private selectModeChange(value: string, oldValue: string) {
      if (!value) {
        this.selectedContact = [];
      }
    }

    private getMyContact() {
      this.$http.get(`/api/address/my-address`).then((response: any) => {
        this.contact = response.data.reverse();
        this.loading = true;
      }, (err: any) => {
        this.loading = true;
      });
    }

    private viewContact(id: string) {
      this.$router.push({ name: 'viewDelivery', params: { id }});
    }

    private deleteContact() {
        Swal.fire({
            title: 'ต้องการลบรายชื่อนี้ใช่หรือไม่',
            text: 'หากยืนยันการลบแล้วข้อมูลจะไม่สามารถกู้คืนได้',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            confirmButtonColor: '#ec1b23',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.confirmedDelete();
            }
        });
    }

    private confirmedDelete() {
        const contactId = this.selectedContact.toString();
        this.$http.delete(`/api/address/${contactId}`).then((response: any) => {
            Swal.fire({
              allowOutsideClick: false,
              title: 'ลบข้อมูลสำเร็จ',
              focusConfirm: false,
              focusCancel: false,
              confirmButtonText: 'ยืนยัน',
              confirmButtonColor: '#ec1b23',
            }).then((result) => {
              if (result.value) {
                  this.selectedContact = [];
                  this.getMyContact();
              }
            });
        }, (err: any) => {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then((result) => {
                // error case
            });
        });
    }
}

